import React, { useState, useEffect } from 'react';
import { translatedTimerLabels } from './dictionary/translateCountDownTimer';
import './styles/CountDownTimer.css';

function CountDownTimer({ targetDate, pageLanguage }) {
    const [timeLeft, setTimeLeft] = useState(() => {
        const now = new Date();
        const difference = targetDate - now;
        if (difference > 0) {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return null;
    });

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date();
            const difference = targetDate - now;

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                });
            } else {
                setTimeLeft(null);
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const labels = translatedTimerLabels[pageLanguage] || translatedTimerLabels['en'];

    if (!timeLeft) {
        return <div className="countdown-container">🎉 {labels.countdown}!</div>;
    }

    return (
        <div className="countdown-container">
            <h4 className="countdown-header">📅 {labels.countdown}</h4>
            <div className="countdown-timer">
                <div className="time-box">
                    <span className="time-value">{timeLeft.days}</span>
                    <span className="time-label">{labels.days}</span>
                </div>
                <div className="time-box">
                    <span className="time-value">{timeLeft.hours}</span>
                    <span className="time-label">{labels.hours}</span>
                </div>
                <div className="time-box">
                    <span className="time-value">{timeLeft.minutes}</span>
                    <span className="time-label">{labels.minutes}</span>
                </div>
                <div className="time-box">
                    <span className="time-value">{timeLeft.seconds}</span>
                    <span className="time-label">{labels.seconds}</span>
                </div>
            </div>
        </div>
    );
}

export default CountDownTimer;
